<template>
	<ejs-stepper
		:key="activeStep"
		:activeStep="activeStep"
		stepType="indicator"
		v-bind:class="cssClass"
		:animation="{enable: enableAnimation}"
	>
		<e-steps>
			<e-step v-for="stepItem in stepItems" :text="stepItem.text" :disabled="true"></e-step>
		</e-steps>
	</ejs-stepper>
</template>
<script>

import { StepperComponent, StepsDirective, StepDirective } from '@syncfusion/ej2-vue-navigations';

export default {
	name: "Stepper",
	/**
	 * - @param {int} activeStep the current selected step
	 * - @param {array} stepItems list of steps in the following form [{text: '..'},...], e.g. [{text: '1'}, {text: '2'},...]
	 * - @param {bool} enableAnimation whether animation shall be activated
	 * - @param {string} cssClass CSS class for ejs-stepper
	 */
	props: {
		activeStep: {
			type: Number,
			required: true,
		},
		stepItems: {
			type: Array,
			required: true,
		},
		enableAnimation: {
			type: Boolean,
			default: true,
		},
		cssClass: {
			type: String,
			default: "",
		},
	},
	components: {
		'ejs-stepper': StepperComponent,
		'e-steps': StepsDirective,
		'e-step': StepDirective
	}
}
</script>
